import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Button, responsiveFontSizes, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Option from "./components/Options";
import RadionButton from "./components/RadioButton";
// const bg = require("./bg.jpeg");
const skipcashBlue = "#1e3f91";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(skipcashBlue),
  backgroundColor: skipcashBlue,
  color: "white",
  textTransform: "capitalize",
  fontFamily: "Roboto",

  "&:hover": {
    backgroundColor: "white",
    borderColor: skipcashBlue,
    borderWidth: 1,
    borderStyle: "solid",
    color: skipcashBlue,
    textTransform: "capitalize",
    fontFamily: "Roboto",
  },
}));

function App() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [name, settName] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [zone, setZone] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [street, setStreet] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [building, setBuilding] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [additionalNotes, setAdditionalNotes] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [speedwraps, setSpeedwraps] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [handwraps, setHandwraps] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [tshitSelected, setTtshitSelected] = useState(false);

  const [section, setSection] = useState({ value: "", err: false, errTxt: "" });
  const [phone, setPhone] = useState({ value: "", err: false, errTxt: "" });
  const [subscription, setSubscription] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [currentSubscription, setCurrentSubscription] = useState(0);
  const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
  const sections = ["Class Packages", "Unlimited Monthly Packages", "WorkShop"];
  const [selectedGlove, setSelectedGlove] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [selectedGloveColor, setSelectedGloveColor] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const classic = [
    "5 sessions (Valid For 1 Month) - 490 QAR",
    "8 sessions (Valid For 1 Month) - 760 QAR",
    "10 sessions (Valid For 90 Days) - 900 QAR",
    "20 sessions (Valid For 40 Days) - 1700 QAR",
  ];
  const monthly = [
    "1 Month - 1100 QAR",
    "3 Months - 2900 QAR",
    "6 Months - 5720 QAR",
    "12 Months - 11000 QAR",
  ];
  const workshops = [
    "Age 13 YRS Above (1 WorkShop) - 150 QAR",
    "Age 13 YRS Above (4 WorkShops) - 500 QAR",
    "Age 12 YRS Below (2 WorkShops) - 200 QAR",
    "Age 12 YRS Below (4 WorkShops) - 400 QAR",
  ];

  const sizes = ["None", "S/M", "X/XL"];
  const heartratething = ["YES", "NO"];
  const colors = [
    "None",
    "Black",
    "Como pink",
    "Grey",
    "Grey urban Como",
    "Pink",
    "Purple",
    "Red",
    "Red and white",
    "Red, white, and blue",
  ];
  const gloves = [
    "None",
    "Gloves - 350 QAR",
    "Gloves limited- 400 QAR",
    "Gloves premium- 450 QAR",
  ];
  const regularGloves = ["black and white", "Pink and black"];
  const limitedGloves = [
    "copper penny",
    "deep teal",
    "matte black",
    "power punch",
  ];
  const premiumGloves = ["Pro leather gloves"];
  const [clicked, setClicked] = useState(false);
  const [calculated, setCalculated] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [flag, setFlag] = useState(false);
  const [grade, setGrade] = useState({ value: "", err: false, errTxt: "" });
  const [currentClass, setCurrentClass] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [currentMonitor, setCurrentMonitor] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [currentGlove, setCurrentGlove] = useState({
    value: "",
    err: false,
    errTxt: "",
  });

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleData = (value, field, index) => {
    if (field === "name") settName({ value, err: false, errTxt: "" });
    else if (field === "email") setEmail({ value, err: false, errTxt: "" });
    else if (field === "phone") setPhone({ value, err: false, errTxt: "" });
    else if (field === "section") {
      setSection({ value, err: false, errTxt: "" });
      // console.log("current section", section.value);
      // if (tshitSelected) {
      //   setTotalAmount(175);
      // } else {
      //   setTotalAmount(0);
      //   setTtshitSelected(false);
      // }
    } else if (field === "subscriptions") {
      setSubscription({ value, err: false, errTxt: "" });
      // 3 Meals + 2 Snacks - 3675 QR
      console.log("the value : ", value);
      let seperated = value.split("-");
      let secondSeperated = seperated[1].split(" ");
      let lastOne = secondSeperated[1];
      console.log("the amount is : ", lastOne);
      let temp = totalAmount - currentSubscription;
      temp = temp + parseInt(lastOne);
      setTotalAmount(temp);
      setCurrentSubscription(parseInt(lastOne));
    } else if (field === "speedwraps") {
      console.log("inside");
      if (value != "None" && !tshitSelected) {
        console.log("inside if", parseInt(totalAmount));

        setTotalAmount(parseInt(totalAmount) + 175);
        setTtshitSelected(true);
      } else if (value != "None" && tshitSelected) {
        setTotalAmount(parseInt(totalAmount));
      } else if (value === "None" && !tshitSelected) {
        setTotalAmount(parseInt(totalAmount));
        setTtshitSelected(false);
      } else {
        setTotalAmount(parseInt(totalAmount) - 175);
        setTtshitSelected(false);
      }
      setSpeedwraps({ value, err: false, errTxt: "" });
    } else if (field === "handwraps") {
      console.log("current field", handwraps.value);
      if (
        value === "None" &&
        handwraps.value != "None" &&
        handwraps.value != ""
      ) {
        console.log("first if");
        let temp = totalAmount - 60;
        setTotalAmount(temp);
      } else if (
        value != "None" &&
        (handwraps.value === "None" || handwraps.value === "")
      ) {
        console.log("second if");
        let temp = totalAmount + 60;
        setTotalAmount(temp);
      }
      setHandwraps({ value, err: false, errTxt: "" });
    } else if (field === "heartrate") {
      if (value === "NO" && currentMonitor.value === "YES") {
        let temp = totalAmount - 380;
        setTotalAmount(temp);
      } else if (
        value === "YES" &&
        (currentMonitor.value === "NO" || currentMonitor.value === "")
      ) {
        let temp = totalAmount + 380;
        setTotalAmount(temp);
      }
      setCurrentMonitor({ value, err: false, errTxt: "" });
    } else if (field === "gloves") {
      console.log("inside gloves");
      let tempTotal = totalAmount;
      if (value === "Gloves - 350 QAR") {
        if (currentGlove.value === "" || currentGlove.value === "None") {
          tempTotal = tempTotal + 350;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves limited- 400 QAR") {
          tempTotal = tempTotal - 50;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves premium- 450 QAR") {
          tempTotal = tempTotal - 100;
          setTotalAmount(tempTotal);
        }
        setCurrentGlove({ value, err: false, errTxt: "" });
      } else if (value === "Gloves limited- 400 QAR") {
        if (currentGlove.value === "" || currentGlove.value === "None") {
          tempTotal = tempTotal + 400;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves - 350 QAR") {
          tempTotal = tempTotal + 50;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves premium- 450 QAR") {
          tempTotal = tempTotal - 50;
          setTotalAmount(tempTotal);
        }
        setCurrentGlove({ value, err: false, errTxt: "" });
      } else if (value === "Gloves premium- 450 QAR") {
        if (currentGlove.value === "" || currentGlove.value === "None") {
          tempTotal = tempTotal + 450;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves - 350 QAR") {
          tempTotal = tempTotal + 100;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves limited- 400 QAR") {
          tempTotal = tempTotal + 50;
          setTotalAmount(tempTotal);
        }
        setCurrentGlove({ value, err: false, errTxt: "" });
      } else if (value === "None") {
        if (currentGlove.value === "Gloves premium- 450 QAR") {
          tempTotal = tempTotal - 450;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves - 350 QAR") {
          tempTotal = tempTotal - 350;
          setTotalAmount(tempTotal);
        } else if (currentGlove.value === "Gloves limited- 400 QAR") {
          tempTotal = tempTotal - 400;
          setTotalAmount(tempTotal);
        }
        setCurrentGlove({ value, err: false, errTxt: "" });
      }
    } else console.log("All good");
  };
  const validateEmail = (email) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
  };

  const pay = async () => {
    setClicked(true);
    const nameRegEx = /^[A-Za-z ]+$/;
    const numRegEx = new RegExp("^[0-9]*$");
    if (name.value === "") {
      settName({
        value: "",
        err: true,
        errTxt: "Name cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (!nameRegEx.test(name.value)) {
      settName({
        value: "",
        err: true,
        errTxt: "Name can only have English Letters",
      });
      setClicked(false);
      return;
    }

    if (phone.value === "") {
      setPhone({
        value: "",
        err: true,
        errTxt: "Phone Number cannot be empty",
      });
      setClicked(false);
      return;
    }
    if (!numRegEx.test(phone.value)) {
      setPhone({
        value: "",
        err: true,
        errTxt: "Invalid Phone Number",
      });
      setClicked(false);
      return;
    }
    if (email.value === "") {
      setEmail({ value: "", err: true, errTxt: "Email cannot be empty" });
      setClicked(false);
      return;
    }

    if (!validateEmail(email.value)) {
      setEmail({
        value: "",
        err: true,
        errTxt: "Invalid Email",
      });
      setClicked(false);
      return;
    }
    if (subscription.value === "") {
      alert("Please Add Subscription");
      setClicked(false);
      return;
    }
    if (section.value === "") {
      alert("Please Add Section");
      setClicked(false);
      return;
    }
    if (speedwraps.value === "") {
      alert("Please Add speedwraps");
      setClicked(false);
      return;
    }
    if (handwraps.value === "") {
      alert("Please Add handwraps");
      setClicked(false);
      return;
    }
    if (currentMonitor.value === "") {
      alert("Please Add a Heart monitor");
      setClicked(false);
      return;
    }
    if (currentGlove.value === "") {
      alert("Please Add Gloves");
      setClicked(false);
      return;
    }

    // alert(amount.value);

    // if (recieve === "") {
    //   alert("Missing or Invalid Details");
    //   setClicked(false);

    //   return;
    // }
    if (totalAmount > 60000) {
      alert("Total Amount Should Be Less than 60000");
      setClicked(false);

      return;
    }

    const url = "https://nine-rounds.herokuapp.com/pay";
    //const url = "http://localhost:4000/pay";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name.value,
        phoneNumber: phone.value,
        amount: totalAmount,
        email: email.value,
        subscription: subscription.value,
        section: section.value,
        speedwraps: speedwraps.value,
        handwraps: handwraps.value,
        monitor: currentMonitor.value,
        selectedGlove: currentGlove.value,
        selectedGloveColor: selectedGloveColor.value,
      }),
    });
    const json = await response.json();
    console.log("json : ", json);

    window.location = json.payUrl;
  };

  // useEffect(() => {
  //   calculateTotal();
  // }, [flag]);

  // const calculateTotal = () => {
  //   let total = 0;
  //   setCalculated(true);
  //   if (delivery) total = total + 40;
  //   setTotalAmount(total);
  // };
  const handleChange = (value) => {
    let tempTotal = totalAmount;
    let test = tempTotal % 150 == 0;
    if (value === "Delivery") {
      tempTotal = tempTotal + 40;
      setShowNote(false);
    } else if (value === "Pickup" && !test) {
      tempTotal = tempTotal - 40;
      setShowNote(true);
    } else {
      setShowNote(true);
    }
    setTotalAmount(tempTotal);
  };

  const styles = {
    container: {
      backgroundColor: "#F1F2F2",
      width: "100%",
      // height: "100%",
      height: "auto",
      margin: 0,
      display: "flex",
      overflow: "hidden",
      flex: 1,
      flexDirection: "column",
      minHeight: "100%",
    },
    whiteContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "5%",
      paddingBottom: "5%",
      // height: "100%",sz
      height: "auto",
    },
    mobileButton: {
      width: "100%",
      padding: "5%",
      borderRadius: 10,
      fontStyle: "Roboto",
      fontSize: "1em",
      height: 40,
    },
    desktopButton: {
      width: "100%",
      padding: "2%",
      borderRadius: 10,
      fontStyle: "Roboto",
      fontSize: "1.2em",
      height: 20,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.whiteContainer}>
        <div
          style={{
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "transparent",
            borderRadius: 10,
            width: "90%",
            background: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={logo} style={{ height: windowDimensions.height / 5 }} />
          </div>

          <div
            style={{
              fontFamily: "Roboto",
              marginLeft: "5%",
              marginRight: "5%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h3>9Round PayMe Checkout</h3>
            </div>
            {console.log("current Glove : ", currentGlove.value)}
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TextField
                fullWidth
                label=" Name"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "name")}
                error={name.err}
                helperText={name.errTxt}
                type="text"
              />
            </div>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TextField
                fullWidth
                label="Phone Number"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "phone")}
                error={phone.err}
                helperText={phone.errTxt}
                type="number"
              />
            </div>

            <div
              style={{
                marginTop: "1%",
              }}
            >
              <TextField
                fullWidth
                label="Email"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "email")}
                error={email.err}
                helperText={email.errTxt}
                type="email"
              />
            </div>
            <div></div>
            <h4>Package</h4>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Option
                categories={sections}
                handleData={handleData}
                label={"Package"}
                fontStyle={styles.fontSizeStyle}
                field={"section"}
                fullWidth
                style={{ width: "48%" }}
              />
            </div>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {/* <Option
                categories={
                  activity.value === "Swimming"
                    ? swimming
                    : activity.value === "Gymnastic"
                    ? gymnastic
                    : activity.value === "Ballet"
                    ? ballet
                    : activity.value === "Table Tennis"
                    ? tennis
                    : activity.value === "Fitness"
                    ? fitness
                    : activity.value === "Robotics"
                    ? robotics
                    : activity.value === "Emergency First Response (EFR)"
                    ? eer
                    : []
                }
                handleData={handleData}
                label={"Section"}
                fontStyle={styles.fontSizeStyle}
                field={"section"}
                fullWidth
                style={{ width: "48%" }}
              /> */}

              {section.value === "Class Packages" ? (
                <Option
                  categories={classic}
                  handleData={handleData}
                  label={"subscription"}
                  fontStyle={styles.fontSizeStyle}
                  field={"subscriptions"}
                  fullWidth
                  style={{ width: "48%" }}
                />
              ) : section.value === "Unlimited Monthly Packages" ? (
                <Option
                  categories={monthly}
                  handleData={handleData}
                  label={"subscription"}
                  fontStyle={styles.fontSizeStyle}
                  field={"subscriptions"}
                  fullWidth
                  style={{ width: "48%" }}
                />
              ) : section.value === "WorkShop" ? (
                <Option
                  categories={workshops}
                  handleData={handleData}
                  label={"subscription"}
                  fontStyle={styles.fontSizeStyle}
                  field={"subscriptions"}
                  fullWidth
                  style={{ width: "48%" }}
                />
              ) : null}
            </div>
            <h4>Speed Wraps</h4>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Option
                categories={sizes}
                handleData={handleData}
                label={"Speed Wraps"}
                fontStyle={styles.fontSizeStyle}
                field={"speedwraps"}
                fullWidth
                style={{ width: "48%" }}
              />
            </div>

            <h4>Hand Wraps</h4>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Option
                categories={colors}
                handleData={handleData}
                label={"Handle Wraps"}
                fontStyle={styles.fontSizeStyle}
                field={"handwraps"}
                fullWidth
                style={{ width: "48%" }}
              />
            </div>
            <h4>Heart Rate Monitor</h4>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Option
                categories={heartratething}
                handleData={handleData}
                label={"Heart Rate Monitor"}
                fontStyle={styles.fontSizeStyle}
                field={"heartrate"}
                fullWidth
                style={{ width: "48%" }}
              />
            </div>
            <h4>Gloves</h4>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Option
                categories={gloves}
                handleData={handleData}
                label={"Gloves"}
                fontStyle={styles.fontSizeStyle}
                field={"gloves"}
                fullWidth
                style={{ width: "48%" }}
              />
            </div>
            {currentGlove.value === "Gloves - 350 QAR" ? (
              <Option
                categories={regularGloves}
                handleData={handleData}
                label={"GloveColor"}
                fontStyle={styles.fontSizeStyle}
                field={"GloveColors"}
                fullWidth
                style={{ width: "48%" }}
              />
            ) : currentGlove.value === "Gloves limited- 400 QAR" ? (
              <Option
                categories={limitedGloves}
                handleData={handleData}
                label={"GloveColor"}
                fontStyle={styles.fontSizeStyle}
                field={"GloveColors"}
                fullWidth
                style={{ width: "48%" }}
              />
            ) : currentGlove.value === "Gloves premium- 450 QAR" ? (
              <Option
                categories={premiumGloves}
                handleData={handleData}
                label={"GloveColor"}
                fontStyle={styles.fontSizeStyle}
                field={"GloveColor"}
                fullWidth
                style={{ width: "48%" }}
              />
            ) : null}
            {/* New code */}

            {/* <h5>Would you like to :</h5>
            <RadionButton dcategory={dcategory} handleChange={handleChange} />
            {showNote && (
              <h6 style={{ color: "red" }}>
                Note: Please collect it from the studio
              </h6>
            )} */}
            <div
              style={{
                marginTop: "1.5%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <h3
                style={{
                  fontStyle: "Roboto",
                  fontSize: "1.1em",
                  opacity: 0.3,
                }}
              >
                Total
              </h3>
              <h3
                style={{
                  fontStyle: "Roboto",
                  fontSize: "1.1em",
                  // opacity: 0.3,
                }}
              >
                {`${totalAmount} QAR`}
              </h3>
            </div>
          </div>

          <div
            style={{
              // height: windowDimensions.height / 3,
              display: "flex",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "90%", padding: "2%" }}>
              {clicked ? (
                <LoadingButton
                  loading
                  variant="outlined"
                  style={
                    windowDimensions.width < 1000
                      ? styles.mobileButton
                      : styles.desktopButton
                  }
                >
                  SUBMIT
                </LoadingButton>
              ) : (
                <ColorButton
                  onClick={() => pay()}
                  style={
                    windowDimensions.width < 1000
                      ? styles.mobileButton
                      : styles.desktopButton
                  }
                >
                  Proceed to Pay
                </ColorButton>
              )}
            </div>

            {/* <h1>hello</h1> */}
          </div>
          <div
            style={{
              // padding: "5%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <img
              src={skip}
              style={
                windowDimensions.width < 1000
                  ? { height: windowDimensions.width / 8 }
                  : { height: windowDimensions.width / 25 }
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
